import $ from "jquery"
import { trace } from "./helpers.js"


const SIV = {

  selector: '[data-siv]',
  singleShotMode: false,

  // update 
  update() {
    $(this.selector).addClass("siv-element");
    this.handler();
  },

  // event handler
  handler() {
    $(this.selector).each( (index, el)=> {      
      if (this.isElementInViewport(el)) {
        $(el).addClass("siv-in");
      } else if (!this.singleShotMode) {
        $(el).removeClass("siv-in");
      }
    });
  },

  isElementInViewport(el) {
    if ((typeof jQuery == 'function') && (el instanceof jQuery)) {
      el = el[0]
    }
    let rect = el.getBoundingClientRect();
    return (rect.top <= (window.innerHeight || document.documentElement.clientHeight)) && ( rect.left <= (window.innerWidth || document.documentElement.clientWidth));
  },

  addEventListeners() {
    $(window).on( 'DOMContentLoaded load resize scroll touchmove', this.handler.bind(this));
  },

  // reset SIV
  reset() {
    $(this.selector).removeClass('siv-element');
    $(this.selector).removeClass('siv-in');
    $(window).off( 'DOMContentLoaded load resize scroll touchmove', this.handler )
  },

  // ### init ###
  init() {
    this.reset();
    this.addEventListeners();
    this.update();
  }

}

export default SIV;